<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
@if (contentfulRelatedProductsList$.asObservable() | async; as contentfulRelatedProductsListContent) {
  <div class="container related-products">
    @if (contentfulRelatedProductsListContent.length > 0) {
      <div class="row mt-4 justify-content-center align-items-baseline">
        <h3 i18n="@@contentful.relatedProducts" class="related-products__title text-center text-uppercase">Related products</h3>
        @for (contentfulRelatedProducts of contentfulRelatedProductsListContent; track contentfulRelatedProducts) {
          @if (contentfulRelatedProducts.title !== 'empty-content') {
            <div class="col-12 col-md-4 mt-5">
              @if (contentfulRelatedProducts.slug) {
                <a [href]="contentfulRelatedProducts.slug">
                  <!--
                  Products are always displayed in the same size. We load the image to a width of 200px and 1.05 scale at hover.
                  The srcset attribute is used to provide images in different sizes based on screen resolution. 210px for all devices and 420px for high resolution screens (200 + 1.05 scale)
                  Applying the webp format, quality percentage and the width of the image will reduce the image size and improve the performance
                  More info: https://www.contentful.com/developers/docs/references/images-api/
                  -->
                  @if (contentfulRelatedProducts.thumbnailImageUrl) {
                    <img
                      [srcset]="
                        contentfulRelatedProducts.thumbnailImageUrl +
                        '?fm=webp&q=75&w=210 1x,' +
                        contentfulRelatedProducts.thumbnailImageUrl +
                        '?fm=webp&q=75&w=420 2x, '
                      "
                      [src]="contentfulRelatedProducts.thumbnailImageUrl + '?fm=webp&q=75&w=210'"
                      [alt]="contentfulRelatedProducts.description"
                    />
                  }
                  <p class="mt-3">{{ contentfulRelatedProducts.title }}</p>
                </a>
                <div class="related-products__buy-button">
                  <a class="btn btn-primary" [href]="contentfulRelatedProducts.slug">
                    <span i18n="@@BuyNow">Shop Now</span>
                  </a>
                </div>
              }
            </div>
          }
        }
      </div>
    }
  </div>
}
